import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const COOKIE_NAME = 'dekalio_cookie_consent';
const COOKIE_MAX_AGE_DAYS = 365;

function getConsentCookie() {
  const cookies = document.cookie.split(';');
  const consent = cookies.find((c) => c.trim().startsWith(`${COOKIE_NAME}=`));
  return consent ? consent.split('=')[1]?.trim() : null;
}

function setConsentCookie(value) {
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${COOKIE_NAME}=${value}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getConsentCookie());
  }, []);

  const handleAccept = () => {
    setConsentCookie('true');
    setVisible(false);
  };

  const handleDecline = () => {
    setConsentCookie('false');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Alert
      className={cn(
        'fixed bottom-0 left-0 right-0 z-50 rounded-none border-x-0 border-b-0 border-t',
        'bg-[#2B373B] text-white border-[#3d4a4f]',
        'flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between p-4 shadow-lg'
      )}
    >
      <AlertDescription className="flex flex-col gap-1 text-white/95 m-0">
        <span>
          Vi använder cookies för att förbättra din upplevelse på vår webbplats.
          Genom att fortsätta använda webbplatsen godkänner du användningen av
          cookies.
        </span>
        <span className="text-xs text-white/70">
          Läs mer i vår{' '}
          <Link
            to="/cookies"
            className="underline hover:no-underline text-white/90"
          >
            cookiepolicy
          </Link>{' '}
          och{' '}
          <Link
            to="/integritetspolicy"
            className="underline hover:no-underline text-white/90"
          >
            integritetspolicy
          </Link>
        </span>
      </AlertDescription>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          type="button"
          variant="outline"
          size="default"
          onClick={handleDecline}
          className="border-white/50 text-white bg-transparent hover:bg-white/10 hover:text-white"
        >
          Avböj
        </Button>
        <Button type="button" size="default" onClick={handleAccept}>
          Jag godkänner
        </Button>
      </div>
    </Alert>
  );
}
